<template>
    <div class="content-wrapper">
        <PageHeader :screenName="'Colaborador ' + form.nome" :linkItems="linkItems" />

        <ErrorModal :modalShow="modalError.showModal" :typeModal="modalError.typeModal"
            :caseModal="modalError.caseModal" @confirmed="redirectToList" />

        <main class="card">
            <div v-if="loadingData" class="d-flex justify-content-center my-3">
                <output class="spinner-border text-custom-blue" aria-live="polite" aria-busy="true">
                    <span class="sr-only">Loading...</span>
                </output>
            </div>
            <section v-else class="form p-2">

                <b-form>
                    <div class="top-right-button">
                        <b-button class="d-flex align-items-center" @click="$router.back()" variant="primary-button">
                            <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                            <span class="align-middle">Voltar</span>
                        </b-button>
                    </div>
                    <b-row>
                        <b-col class="pb-1" lg="6" md="12" sm="12">
                            <b-form-group label="Departamento Regional" label-class="font-weight-bold">
                                <vue-perfect-scrollbar :settings="settings">
                                    <div>
                                        {{ form.departamento }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                        <b-col class="pb-1" lg="6" md="12" sm="12">
                            <b-form-group label="Unidade Operacional" label-class="font-weight-bold">
                                <vue-perfect-scrollbar :settings="settings">
                                    <div>
                                        {{ form.unidade_operacional }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="pb-1" lg="6" md="12" sm="12">
                            <b-form-group label="CNPJ" label-class="font-weight-bold">
                                <vue-perfect-scrollbar :settings="settings">
                                    <div>
                                        {{ form.cnpj }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                        <b-col class="pb-1" lg="6" md="12" sm="12">
                            <b-form-group label="Razão Social" label-class="font-weight-bold">
                                <vue-perfect-scrollbar :settings="settings">
                                    <div>
                                        {{ form.razao_social }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="pb-2" lg="6" md="6" sm="12">
                            <b-form-group label="Nome" label-class="font-weight-bold">
                                <vue-perfect-scrollbar :settings="settings">
                                    <div>
                                        {{ form.nome }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                        <b-col class="pb-2" lg="6" md="6" sm="12">
                            <b-form-group label="Data de Nascimento" label-class="font-weight-bold">
                                <vue-perfect-scrollbar :settings="settings">
                                    <div>
                                        {{ form.data_nascimento }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                        <b-col class="pb-2" lg="6" md="6" sm="12">
                            <b-form-group label="CPF" label-class="font-weight-bold">
                                <vue-perfect-scrollbar :settings="settings">
                                    <div>
                                        {{ form.cpf }}
                                    </div>
                                </vue-perfect-scrollbar>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>

                <b-card class="mt-2" v-if="aplicacoes.length > 0">
                    <h5 class="mb-2">Histórico de Aplicações</h5>
                    <b-table :items="aplicacoes" :fields="fieldsAplicacoes" striped hover small responsive>
                        <template #cell(data_aplicacao)="data">
                            {{ data.item.data_aplicacao }}
                        </template>
                    </b-table>
                </b-card>

                <b-row class="buttons">
                    <b-col cols="12" class="d-flex flex-wrap gap-1">
                        <b-button v-if="canEdit" id="redirect-edit" class="mr-2" variant="custom-blue"
                            :disabled="loadingData" @click.prevent="redirectToEdit">
                            <feather-icon icon="EditIcon" class="mr-50" />
                            Editar
                        </b-button>

                        <b-button v-if="this.aplicacoes.length > 0" id="redirect-vacinacao" variant="success" :disabled="loadingData"
                            @click.prevent="redirectToRegistroVacinacao">
                            <feather-icon icon="FileTextIcon" class="mr-50" />
                            Registro de Vacinação
                        </b-button>
                    </b-col>
                </b-row>
            </section>

        </main>
    </div>
</template>

<script>
import {
    BRow, BCol, BForm, BFormGroup, BFormInput,
    BFormRadio, BButton, BFormTextarea, BLink,
    BTable, VBTooltip, BCard
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import ErrorModal from '@/views/components/custom/modals/ErroIdInexistenteModal.vue'
import { getIdPessoaFisica } from '@core/utils/store/getStore';
import { setIdPessoaFisica } from '@core/utils/store/setStore';
import { actions, subjects } from "@/libs/acl/rules";

export default {
    title: 'Visualizar Colaborador',
    components: {
        BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BFormTextarea,
        BButton, PageHeader, VuePerfectScrollbar, ErrorModal, BLink,
        BTable, VBTooltip, BCard
    },

    data() {
        return {
            settings: {
                maxScrollbarLength: 70,
                wheelSpeed: 0.2,
                wheelPropagation: false
            },
            linkItems: [
                {
                    name: 'Busca Avançada',
                    routeName: 'busca-avancada'
                },
                {
                    name: 'Carregando dados...',
                    active: true
                }
            ],
            modalError: {
                showModal: false,
                typeModal: 'error',
                caseModal: 'idInexistente'
            },
            form: {
                departamento: '',
                unidade_operacional: '',
                cnpj: '',
                razao_social: '',
                nome: '',
                cpf: '',
                data_nascimento: '',
            },
            loadingData: true,
            canEdit: false,
            canManageColab: false,
            aplicacoes: [],
            fieldsAplicacoes: [
                { key: 'vacina', label: 'Vacina' },
                { key: 'lote', label: 'Lote' },
                { key: 'data_aplicacao', label: 'Data de Aplicação' },
                { key: 'departamento', label: 'Departamento' },
                { key: 'unidade_operacional', label: 'Unidade Operacional' },
            ],
        }
    },
    async mounted() {
        this.canManageColab = this.$can(
            actions.GERENCIAR,
            subjects.COLABORADOR_MENUS_ROTAS
        );

        if ((getIdPessoaFisica() === null || typeof getIdPessoaFisica() == 'undefined') && typeof this.$route.params.id_pessoa_fisica == "undefined") {
            this.openModalError();
            return;
        }

        if (typeof this.$route.params.id_pessoa_fisica != "undefined") {
            if (this.$route.params.id_pessoa_fisica !== getIdPessoaFisica()) {
                setIdPessoaFisica(this.$route.params.id_pessoa_fisica);
            }
        }
        await this.$http.get(this.$api.buscaAvancada(), { params: { id_pessoa_fisica: getIdPessoaFisica(), id_empresa: this.$route.params.id_empresa, pagina: 1 } }).then(({ data }) => {
            this.preenchimentoFormulario(data.data[0]);
            this.linkItems[1].name = 'Colaborador ' + data.data[0].colaborador.nome;
        })

        this.canEdit = this.canEditColaborador();
    },

    methods: {
        preenchimentoFormulario(dados) {
            this.form.id_departamento = dados.empresa.id_departamento;
            this.form.id_unidade = dados.empresa.id_unidade;
            this.form.editavel = dados.colaborador.editavel;
            this.form.vacinado = dados.colaborador.vacinado;
            this.form.pode_gerenciar_colaboradores = dados.pode_gerenciar_colaboradores;
            this.form.departamento = dados.empresa.departamento;
            this.form.unidade_operacional = dados.empresa.unidade_operacional;
            this.form.cnpj = dados.empresa.cnpj;
            this.form.razao_social = dados.empresa.razao_social;
            this.form.nome = dados.colaborador.nome;
            this.form.cpf = dados.colaborador.cpf;
            this.form.data_nascimento = dados.colaborador.data_nascimento;
            this.aplicacoes = dados.aplicacoes || [];
            this.loadingData = false;
        },

        openModalError() {
            this.modalError.showModal = true;
        },

        canEditColaborador() {
            return this.form.editavel && !this.form.vacinado && this.form.pode_gerenciar_colaboradores && this.canManageColab;
        },

        redirectToList() {
            this.$router.push({ name: 'busca-avancada' });
        },

        redirectToEdit() {
            this.$http.get(this.$api.buscaAvancada(), {
                params: { id_pessoa_fisica: getIdPessoaFisica(), pagina: 1 }
            }).then(({ data }) => {
                const dados = data.data[0];

                this.$router.push({
                    name: "empresa-colaborador-edit",
                    params: {
                        idPessoa: dados.colaborador.id_pessoa_fisica,
                        cpf: dados.colaborador.cpf,
                        nome: dados.colaborador.nome,
                        genero: dados.colaborador.genero,
                        data_nascimento: moment(dados.colaborador.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                        nome_mae: dados.colaborador.nome_mae,
                        id_nacionalidade: dados.colaborador.id_nacionalidade,
                        descricao_nacionalidade: dados.colaborador.descricao_nacionalidade,
                        categoria: {
                            id_categoria: dados.colaborador.id_categoria,
                            descricao: dados.colaborador.categoria,
                        },
                        empresa: dados.empresa,
                        ano: dados.colaborador.ano,
                        editavel: dados.colaborador.editavel,
                        setor: dados.colaborador.setor,
                        matricula: dados.colaborador.matricula,
                    },
                });
            }).catch((err) => {
                console.error('Erro ao buscar dados do colaborador:', err);
            });
        },

        redirectToRegistroVacinacao() {
            this.$router.push({
                name: 'vacinacao-list',
            });
        },
    }
}
</script>

<style>
.custom {
    padding: 5px 10px;
    margin-right: 10px;
    margin-bottom: 5px;
    font-weight: 400;
}

legend {
    color: #5E5873;
}

.font-size-16 {
    font-size: 16px;
    line-height: 21px;
}

.altura_max_input_scrollbar {
    max-height: 32px;
    word-break: break-all;
    padding-right: 15px;
}

.altura_max_textarea_scrollbar {
    max-height: 113px;
    word-break: break-all;
    padding-right: 15px;
}

.top-right-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 10;
}
</style>